import React from "react";
import locale from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { MultiSelectFilter } from "./_common/multi-select-filter";
import { useBookingProfile_GetTagsQuery } from "@graphql";

type Option = { label: string; value: string | null };

export type BookingKitTagFilterProps = {
  label?: string;
  options?: Option[];
} & FilterWithFavouriteProps;

export const BookingKitTagFilter = ({
  label,
  options,
  ...props
}: BookingKitTagFilterProps) => {
  const { data: tagsData } = useBookingProfile_GetTagsQuery({
    fetchPolicy: "cache-first"
  });

  const tagsOpt = tagsData?.config.bookingTags
    .filter((x) => x.bookingKit)
    .map((x) => ({
      label: x.label,
      value: x.code
    }));

  const _options = options ? options : tagsOpt ?? [];

  const title = label ?? locale.kitTableColumnType.ManagementStatus;

  return (
    <MultiSelectFilter
      label={title}
      options={_options as any}
      {...props}
    />
  );
};
